import axios from 'axios';

const instance = axios.create({
	baseURL: 'https://my-burger-king.firebaseio.com/'
});

export default instance;



// WEBPACK FOOTER //
// ./src/axios-orders.js